import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StandardOverview.module.css';

const OverviewHeader = ({ model }) => {
    const navigate = useNavigate();

    return (
        <header className={styles.pageHeader}>
            <div className={styles.pageHeaderMain}>
                <p className={styles.pageEyebrow}>Project Overview</p>
                <h1 className={styles.pageTitle}>{model.projectName}</h1>
                <p className={styles.pageSubtitle}>{model.subtitle}</p>
                <ul className={styles.metaRow}>
                    {model.metaItems.map(item => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
            </div>
            <div className={styles.pageHeaderActions}>
                <button type="button" className={styles.textAction} onClick={() => navigate('/EditProject')}>
                    View project information →
                </button>
                <button type="button" className={styles.textAction} onClick={() => navigate('/team/vdr')}>
                    Manage team &amp; access →
                </button>
            </div>
        </header>
    );
};

export default OverviewHeader;
